/* TAARASH — small storefront behaviours (no dependencies) */
(function () {
  'use strict';

  /* Announcement bar: rotate messages */
  function initAnnouncements(root) {
    root.querySelectorAll('[data-t-announce]').forEach(function (bar) {
      if (bar.dataset.tReady) return;
      bar.dataset.tReady = '1';
      var msgs = bar.querySelectorAll('.t-announce__msg');
      if (msgs.length < 2) return;
      var i = 0;
      var delay = parseInt(bar.dataset.speed || '4500', 10);
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, delay);
    });
  }

  /* Category slider arrows */
  function initSliders(root) {
    root.querySelectorAll('[data-t-slider]').forEach(function (wrap) {
      if (wrap.dataset.tReady) return;
      wrap.dataset.tReady = '1';
      var track = wrap.querySelector('[data-t-track]');
      var prev = wrap.querySelector('[data-t-prev]');
      var next = wrap.querySelector('[data-t-next]');
      if (!track) return;

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        wrap.dataset.overflow = max > 0 ? 'true' : 'false';
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }

      function step(dir) {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Back-to-top button */
  function initTop() {
    var btn = document.querySelector('[data-t-top]');
    if (!btn || btn.dataset.tReady) return;
    btn.dataset.tReady = '1';
    function onScroll() {
      btn.classList.toggle('is-visible', window.scrollY > 700);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    onScroll();
  }

  function init(root) {
    initAnnouncements(root || document);
    initSliders(root || document);
    initTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Re-initialise when sections are edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
